import { loadEsri, Query, QueryTask } from '../services/esriLoadService'
import loggingService from './util/loggingService'
import axios from 'axios'

const appConfig = require('../../static/config/config.json')

var isDebug = false
var serviceUrlsSet = false
var gisToken
const gisServiceUrls = {}

gisServiceUrls.querySection = appConfig.gis_url + appConfig.Map_QuerySectionEndpoint
gisServiceUrls.querySitePoints = appConfig.gis_url + appConfig.Map_QuerySitePointsEndpoint
gisServiceUrls.querySiteLines = appConfig.gis_url + appConfig.Map_QuerySiteLinesEndpoint
gisServiceUrls.querySitePolys = appConfig.gis_url + appConfig.Map_QuerySitePolygonsEndpoint
gisServiceUrls.queryDistrict = appConfig.gis_url + appConfig.Map_QueryDistrictsEndpoint
gisServiceUrls.ShapefileService = appConfig.gis_url + appConfig.Map_GenerateServiceEndpoint
gisServiceUrls.queryIsolates = appConfig.gis_url + appConfig.Map_QueryIsolatesEndpoint
gisServiceUrls.queryProvSitePoints = appConfig.gis_url + appConfig.Map_QueryProvSitePointsEndpoint
gisServiceUrls.queryProvSiteLines = appConfig.gis_url + appConfig.Map_QueryProvSiteLinesEndpoint
gisServiceUrls.queryLithicLandscapes = appConfig.gis_url + appConfig.Map_QueryLithicLandscapesEndpoint
gisServiceUrls.queryInvPoints = appConfig.gis_url + appConfig.Map_QueryInvestigationPointsEndpoint
gisServiceUrls.queryInvLiness = appConfig.gis_url + appConfig.Map_QueryInvestigationLinesEndpoint
gisServiceUrls.queryInvPoly = appConfig.gis_url + appConfig.Map_QueryInvestigationPolyEndpoint

function log (message, object) {
    loggingService.log(isDebug, 'gisService', message)
    if (object) {
        loggingService.logRaw(isDebug, object)
    }
}

function setGisServiceUrls (tok) {
    if (!serviceUrlsSet) {
        gisToken = tok
        var tokenQuery = '?token=' + gisToken

        //append tokenQuery to all gisServiceUrl object properties
        for (const [key] of Object.entries(gisServiceUrls)) {
            gisServiceUrls[key] += tokenQuery
        }
        // gisServiceUrls.querySection += tokenQuery
        // gisServiceUrls.querySitePoints += tokenQuery
        // gisServiceUrls.querySiteLines += tokenQuery
        // gisServiceUrls.querySitePolys += tokenQuery
        // gisServiceUrls.queryDistrict += tokenQuery
        // gisServiceUrls.ShapefileService += tokenQuery
        // gisServiceUrls.queryIsolates += tokenQuery
        // gisServiceUrls.queryProvSitePoints += tokenQuery
        // gisServiceUrls.queryProvSiteLines += tokenQuery
        // gisServiceUrls.queryLithicLandscapes += tokenQuery
        serviceUrlsSet = true
    }
    return
}

function getToken () {
    return gisToken
}

function trsQuerySection (trsDto) {
    return new Promise((resolve, reject) => {
        loadEsri('GisQuerySection').then(() => {
            var querytask = new QueryTask(gisServiceUrls.querySection)
            //Construct the query
            var query = new Query()
            //return all fields
            query.outFields = ['*']
            //return the geometry to be used for in the *TrsLayerQueryTaskCompleted function
            query.returnGeometry = true
            //parse trsDto into trs query
            var township = trsDto.Township + trsDto.TownshipDirection
            var range = trsDto.Range + trsDto.RangeDirection
            query.where = 'TDISPLAY = \'' + township.toUpperCase() + '\' AND RDISPLAY = \'' + range.toUpperCase() + '\''
            // Add the section to the query if provided
            if (trsDto.Sections.length > 0) {
                query.where += ' AND (1=2'
                trsDto.Sections.forEach(section => {
                    query.where += ' OR SECTION_ = ' + section
                })
                query.where += ')'
            }
            //On complete, pass results to the trsIsolateQueryOnLayerQueryComplete function
            querytask.execute(query).then(results => {
                resolve(results)
            })
        })
    })
}

function siteTrsLayerQuery (trsDto) {
    log('starting TRS Layer Query', trsDto)
    return new Promise((resolve, reject) => {
        trsQuerySection(trsDto).then(results => {
            trsSiteQueryOnLayerQueryComplete(results).then(results2 => {
                resolve(results2)
            })
        })
    })
}

function trsSiteQueryOnLayerQueryComplete (results) {
    return new Promise((resolve, reject) => {
        log('starting TRS Site Query', results)
        var pointsQueryTask = new QueryTask(gisServiceUrls.querySitePoints)
        var linesQueryTask = new QueryTask(gisServiceUrls.querySiteLines)
        var polygonsQueryTask = new QueryTask(gisServiceUrls.querySitePolys)
        var districtQueryTask = new QueryTask(gisServiceUrls.queryDistrict)
        var proSiteLinesQueryTask = new QueryTask(gisServiceUrls.queryProvSiteLines)
        var lithicLandscapesQueryTask = new QueryTask(gisServiceUrls.queryLithicLandscapes)

        var resultsFeatureSet = results.features
        var siteResults = []
        var ptsLnsPlynsPromises = []
        if (resultsFeatureSet.length > 0) {
            resultsFeatureSet.forEach(feature => {
                var query = new Query()
                query.geometry = feature.geometry
                log('site query geom:', query.geometry)
                //Set the spatial query type
                query.spatialRelationship = Query.SPATIAL_REL_INTERSECT
                query.returnGeometry = true //Return Geometries for linking to maps in later realease
                query.outFields = ['*']
                //Execute task
                ptsLnsPlynsPromises.push(pointsQueryTask.execute(query))
                ptsLnsPlynsPromises.push(linesQueryTask.execute(query))
                ptsLnsPlynsPromises.push(polygonsQueryTask.execute(query))
                ptsLnsPlynsPromises.push(districtQueryTask.execute(query))
                ptsLnsPlynsPromises.push(proSiteLinesQueryTask.execute(query))
                ptsLnsPlynsPromises.push(lithicLandscapesQueryTask.execute(query))
            })

            Promise.all(ptsLnsPlynsPromises).then((results) => {
                log('Site Query Complete:', results)
                for (var i = 0; i < results.length; i++) {
                    var featureSet = results[i]
                    for (var featureIndex = 0; featureIndex < featureSet.features.length; featureIndex++) {
                        var element = featureSet.features[featureIndex]
                        if (siteResults.indexOf(element) === -1) {
                            siteResults.push(element)
                        }
                    }
                }
                log('Site Results:', siteResults)
                resolve(siteResults)
            })
        } else {
            resolve([])
        }
    })
}

function siteToTrsQuery (siteDto) {
    return new Promise((resolve, reject) => {
        loadEsri('CulturalResourceGisTest').then(() => {
            //query geometry by passing in site info
            var pointsQueryTask = new QueryTask(gisServiceUrls.querySitePoints)
            var linesQueryTask = new QueryTask(gisServiceUrls.querySiteLines)
            var polygonsQueryTask = new QueryTask(gisServiceUrls.querySitePolys)
            var districtQueryTask = new QueryTask(gisServiceUrls.queryDistrict)
            var proSiteLinesQueryTask = new QueryTask(gisServiceUrls.queryProvSiteLines)
            var lithicLandscapesQueryTask = new QueryTask(gisServiceUrls.queryLithicLandscapes)

            //Construct the query
            var query = new Query()
            //return all fields and return geometry
            query.outFields = ['*']
            query.returnGeometry = true
            //parse siteDto into query
            var countyCode = siteDto.countyCode || ''
            var siteNumber = siteDto.siteNumber || 0
            var segment = siteDto.segment
            query.where = 'County = \'' + countyCode.toUpperCase() + '\' AND SiteNo = ' + siteNumber
            // Add segment to query
            if (!segment || segment === 0) {
                query.where += ' AND (SegmentId IS NULL or SegmentId = 0)'
            } else {
                query.where += ' AND SegmentId = ' + segment
            }
            //Execute task
            var ptsLnsPlynsPromises = []
            ptsLnsPlynsPromises.push(pointsQueryTask.execute(query))
            ptsLnsPlynsPromises.push(linesQueryTask.execute(query))
            ptsLnsPlynsPromises.push(polygonsQueryTask.execute(query))
            ptsLnsPlynsPromises.push(districtQueryTask.execute(query))
            ptsLnsPlynsPromises.push(proSiteLinesQueryTask.execute(query))
            ptsLnsPlynsPromises.push(lithicLandscapesQueryTask.execute(query))

            Promise.all(ptsLnsPlynsPromises).then((results) => {
                siteToTrsQueryOnSiteQueryComplete(results).then(results2 => {
                    resolve(results2)
                })
            })
        })
    })
}

function siteToTrsQueryOnSiteQueryComplete (results) {
    return new Promise((resolve, reject) => {
        var querytask = new QueryTask(gisServiceUrls.querySection)
        var queryPromises = []
        //parse the results
        var resultsFeatureSet = []
        results.forEach(result => {
            resultsFeatureSet = resultsFeatureSet.concat(result.features)
        })

        if (resultsFeatureSet.length > 0) {
            resultsFeatureSet.forEach(feature => {
                var query = new Query()
                query.geometry = feature.geometry
                //Set the spatial query type
                query.spatialRelationship = Query.SPATIAL_REL_INTERSECT
                query.returnGeometry = true //Return Geometries for linking to maps in later realease
                query.outFields = ['*']
                //Execute task
                queryPromises.push(querytask.execute(query))
            })

            Promise.all(queryPromises).then((results2) => {
                var trsList = []
                results2.forEach(result => {
                    result.features.forEach(feature => {
                        trsList.push(feature.attributes.CR_LINK)
                    })
                })
                resolve(trsList.filter((item, index) => trsList.indexOf(item) === index).sort())
            })
        } else {
            resolve([])
        }
    })
}

function getFeaturesFromZip (zipFile, name, targetSR = 4326) {
    return new Promise((resolve, reject) => {
        loadEsri('CulturalResourceGisTest').then(() => {
            var form = new FormData()
            var publishParams = {
                'name': name,
                'targetSR': {
                    'wkid': targetSR
                },
                'maxRecordCount': 1000,
                'enforceInputFileSizeLimit': true,
                'enforceOutputJsonSizeLimit': true
            }
            // generalize features to 10 meters for better performance
            // params.generalize = true;
            // params.maxAllowableOffset = 10;
            // params.reducePrecision = true;
            // params.numberOfDigitsAfterDecimal = 0;
            form.append('publishParameters', JSON.stringify(publishParams))
            form.append('filetype', 'shapefile')
            form.append('f', 'json')
            let zipName = name = '.zip'
            form.append('file', arrayBufferToBlob(zipFile), zipName)

            var instance = axios.create()
            instance.defaults.headers.common['Accept'] = 'application/json'
            loggingService.log(isDebug, 'mapService.getFeaturesFromZip - url: ', gisServiceUrls.ShapefileService)
            instance.post(gisServiceUrls.ShapefileService, form, { withCredentials: false }).then(result => {
                resolve(result)
            })
        })
    })
}

function isolateTrsLayerQuery (trsDto) {
    log('starting Isolate TRS Layer Query', trsDto)
    return new Promise((resolve, reject) => {
        trsQuerySection(trsDto).then(results => {
            trsIsolateQueryOnLayerQueryComplete(results).then(results2 => {
                resolve(results2)
            })
        })
    })
}

function trsIsolateQueryOnLayerQueryComplete (results) {
    return new Promise((resolve, reject) => {
        log('starting TRS Isolate Query', results)
        var isoalteQueryTask = new QueryTask(gisServiceUrls.queryIsolates)

        var resultsFeatureSet = results.features
        var isolateResults = []
        var queryPromises = []
        if (resultsFeatureSet.length > 0) {
            resultsFeatureSet.forEach(feature => {
                var query = new Query()
                query.geometry = feature.geometry
                log('isolate query geom:', query.geometry)
                //Set the spatial query type
                query.spatialRelationship = Query.SPATIAL_REL_INTERSECT
                query.returnGeometry = true //Return Geometries for linking to maps in later realease
                query.outFields = ['*']
                //Execute task
                queryPromises.push(isoalteQueryTask.execute(query))
            })

            Promise.all(queryPromises).then((results) => {
                log('Isolate Query Complete:', results)
                for (var i = 0; i < results.length; i++) {
                    var featureSet = results[i]
                    for (var featureIndex = 0; featureIndex < featureSet.features.length; featureIndex++) {
                        var element = featureSet.features[featureIndex]
                        if (isolateResults.indexOf(element) === -1) {
                            isolateResults.push(element)
                        }
                    }
                }
                log('Isolate Results:', isolateResults)
                resolve(isolateResults)
            })
        } else {
            resolve([])
        }
    })
}

function invTrsLayerQuery (trsDto) {
    log('starting TRS Layer Query', trsDto)
    return new Promise((resolve, reject) => {
        trsQuerySection(trsDto).then(results => {
            trsInvQueryOnLayerQueryComplete(results).then(results2 => {
                resolve(results2)
            })
        })
    })
}

function trsInvQueryOnLayerQueryComplete (results) {
    return new Promise((resolve, reject) => {
        log('starting TRS Investigation Query', results)
        var pointsQueryTask = new QueryTask(gisServiceUrls.queryInvPoints)
        var linesQueryTask = new QueryTask(gisServiceUrls.queryInvLiness)
        var polygonsQueryTask = new QueryTask(gisServiceUrls.queryInvPoly)

        var resultsFeatureSet = results.features
        var invResults = []
        var ptsLnsPlynsPromises = []
        if (resultsFeatureSet.length > 0) {
            resultsFeatureSet.forEach(feature => {
                var query = new Query()
                query.geometry = feature.geometry
                log('inv query geom:', query.geometry)
                //Set the spatial query type
                query.spatialRelationship = Query.SPATIAL_REL_INTERSECT
                query.returnGeometry = true //Return Geometries for linking to maps in later realease
                query.outFields = ['*']
                //Execute task
                ptsLnsPlynsPromises.push(pointsQueryTask.execute(query))
                ptsLnsPlynsPromises.push(linesQueryTask.execute(query))
                ptsLnsPlynsPromises.push(polygonsQueryTask.execute(query))
            })

            Promise.all(ptsLnsPlynsPromises).then((results) => {
                log('Inv Query Complete:', results)
                for (var i = 0; i < results.length; i++) {
                    var featureSet = results[i]
                    for (var featureIndex = 0; featureIndex < featureSet.features.length; featureIndex++) {
                        var element = featureSet.features[featureIndex]
                        if (invResults.indexOf(element) === -1) {
                            invResults.push(element)
                        }
                    }
                }
                log('Inv Results:', invResults)
                resolve(invResults)
            })
        } else {
            resolve([])
        }
    })
}

function arrayBufferToBlob (arraybuff) {
    return new Blob([new Uint8Array(arraybuff)], { type: 'application/zip' })
}

// Utility to run async functions with a max concurrency
async function batchProcess (items, handler, maxConcurrent, onProgress) {
    let results = []
    let totalBatches = Math.ceil(items.length / maxConcurrent)

    for (let i = 0; i < items.length; i += maxConcurrent) {
        const batch = items.slice(i, i + maxConcurrent)
        const batchResults = await Promise.all(batch.map(handler))
        results = results.concat(batchResults)

        if (onProgress) {
            const batchIndex = Math.floor(i / maxConcurrent) + 1
            onProgress(batchIndex, totalBatches)
        }
    }

    return results
}

// function to batch process TRS list to site and inv results
async function processTrsDtoList (trsDtoList, batchSize, onProgress) {
    let siteResults = []
    let invResults = []

    await batchProcess(trsDtoList, async (trsDto) => {
        const sectionResult = await trsQuerySection(trsDto)
        const siteFeatures = await trsSiteQueryOnLayerQueryComplete(sectionResult)
        const invFeatures = await trsInvQueryOnLayerQueryComplete(sectionResult)

        let flatSiteFeatures = [].concat.apply([], siteFeatures)
        flatSiteFeatures.forEach(result => {
            siteResults.push({
                countyCode: result.attributes.County,
                siteNumber: result.attributes.SiteNo,
                segment: result.attributes.SegmentId
            })
        })

        let invFlatFeatures = [].concat.apply([], invFeatures)
        invFlatFeatures.forEach(result => {
            if (result.attributes.DBI) {
                invResults.push({ dbNumber: result.attributes.DBI })
            }
        })

        return true // just placeholder for batchProcess structure
    }, batchSize, onProgress)

    const uniqueSiteResults = dedupeSiteResults(siteResults)
    const uniqueInvResults = dedupeInvResults(invResults)

    return { siteResults: uniqueSiteResults, invResults: uniqueInvResults }
}

function dedupeSiteResults (siteResults) {
    const seen = new Set()
    return siteResults.filter(({ countyCode, siteNumber, segment }) => {
        const key = `${countyCode}|${siteNumber}|${segment}`
        if (seen.has(key)) return false
        seen.add(key)
        return true
    })
}

function dedupeInvResults (invResults) {
    const seen = new Set()
    return invResults.filter(({ dbNumber }) => {
        if (seen.has(dbNumber)) return false
        seen.add(dbNumber)
        return true
    })
}

export default {
    setGisServiceUrls: setGisServiceUrls,
    getToken: getToken,
    siteTrsLayerQuery: siteTrsLayerQuery,
    siteToTrsQuery: siteToTrsQuery,
    getFeaturesFromZip: getFeaturesFromZip,
    isolateTrsLayerQuery: isolateTrsLayerQuery,
    invTrsLayerQuery: invTrsLayerQuery,
    processTrsDtoList: processTrsDtoList
}



// WEBPACK FOOTER //
// ./src/services/gisService.js